import React from 'react';
import PropTypes from 'prop-types';

const FieldErrorDisplay = ({ errorSchema, fieldName }) => {
  const errors = errorSchema?.[fieldName]?.__errors || [];

  if (errors.length === 0) return null;

  return (
    <div className="mt-1 space-y-1">
      {errors.map((error, index) => (
        <span key={index} className="order-form-field-error !mt-1">
          {error}
        </span>
      ))}
    </div>
  );
};

FieldErrorDisplay.propTypes = {
  errorSchema: PropTypes.object,
  fieldName: PropTypes.string.isRequired,
};

export default FieldErrorDisplay;
